import { gsap } from 'gsap';

(function () {
    const langSelector: HTMLElement | null = document.getElementById('lang-selector');
    const list: HTMLElement | null = document.getElementById('lang-selector-list');
    const toggle: HTMLElement | null = document.getElementById('lang-selector-toggle');
    const staggerItems = document.getElementsByClassName('language-selector__list-item');



        const closeNavigation = function () {
            gsap.to(staggerItems, {
                duration: 0.15,
                delay: 0,
                opacity: 0,
                scaleY: 0,
                transformOrigin: 'top',
                stagger: -0.1,
                ease: 'expo.in',

                onComplete: () => {
                    if (list) {
                        list.classList.remove('language-selector__list--open');
                    }
                    if (toggle) {
                        toggle.setAttribute('aria-expanded', 'false');
                        toggle.classList.remove('language-selector__toggle--open');
                    }
                    if (langSelector) {
                        langSelector.removeEventListener('keyup', escapeEvent);
                    }
                },
            });
        };


    const escapeEvent = (event) => {
        if (event.defaultPrevented) {
            return;
        }
        const key = event.key || event.keyCode;

        if (key === 'Escape' || key === 'Esc' || key === 27) {
            closeNavigation();
        }
    };
    
    if (toggle) {
        toggle.onclick = function () {
            closeNavigation();
        };
    }
 
    if (toggle && list && langSelector) {
        toggle.onclick = function () {
            if (list.classList.contains('language-selector__list--open')) {
                closeNavigation();
            } else {
                list.classList.add('language-selector__list--open');
                const listWidth = list.clientWidth;
                const toggleWidth = toggle.clientWidth;
                toggle.setAttribute('aria-expanded', 'true');
                toggle.classList.add('language-selector__toggle--open');
    
                langSelector.addEventListener('keyup', escapeEvent);
                gsap.set(staggerItems, { opacity: 0, scaleY: 0, transformOrigin: 'top' });
                gsap.to(staggerItems, { duration: 0.25, delay: 0, opacity: 1, scaleY: 1, stagger: 0.1, ease: 'back.out' });
            }
        };
    }
    
    if (langSelector) {

        window.addEventListener('click', function (event: Event) {
            const target = event.target as HTMLDivElement;
            if (target && !langSelector.contains(target)) {
                closeNavigation();
            }
        });
    }
})();
